import { render, staticRenderFns } from "./ViewScreenSaver.vue?vue&type=template&id=2b93efa8&scoped=true&"
import script from "./ViewScreenSaver.vue?vue&type=script&lang=ts&"
export * from "./ViewScreenSaver.vue?vue&type=script&lang=ts&"
import style0 from "./ViewScreenSaver.vue?vue&type=style&index=0&id=2b93efa8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b93efa8",
  null
  
)

export default component.exports